module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-kiplinger.bacab81b790801d10328fa384eecdd9e.png";